//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AddApplicant",
  data: function data() {
    return {
      nricFin: ''
    };
  },

  methods: {
    addApplicant: function addApplicant() {
      console.log('\n\n ==== add new applicant nric / fin ==== \n', this.nricFin, '\n ================');
      this.$emit('addApplicant', this.nricFin.toUpperCase());
      this.nricFin = '';
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/bookModuleSession/AddApplicant.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/bookModuleSession/AddApplicant.vue
// module chunks = 8 13